import { __awaiter, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
/**
 * Call to warmup personal data call in SB in 1JS
 */
export function warmupPersonalData(options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var searchPrefetch, searchSettings, searchDispatcher, _b, prefetch, dispatcherModule, tokenProviders, userEntitlements, featureGates, sharePointTokenProvider, sharePointResourceId, shouldFetchPersonalData, dispatcher;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    searchPrefetch = options.searchPrefetch, searchSettings = options.searchSettings, searchDispatcher = options.searchDispatcher;
                    return [4 /*yield*/, Promise.all([
                            searchPrefetch.getModule(),
                            searchDispatcher.getModule(),
                            searchSettings.getTokenProviders(),
                            searchSettings.getUserEntitlements(),
                            fetchFeatureGates(),
                        ])];
                case 1:
                    _b = __read.apply(void 0, [_c.sent(), 5]), prefetch = _b[0], dispatcherModule = _b[1], tokenProviders = _b[2], userEntitlements = _b[3], featureGates = _b[4];
                    sharePointTokenProvider = tokenProviders.sharePointTokenProvider;
                    sharePointResourceId = (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.SharePointResourceId) || '';
                    shouldFetchPersonalData = ((_a = featureGates.result.searchGates) === null || _a === void 0 ? void 0 : _a.searchFetchPersonalDataEnabled) ||
                        false;
                    if (!sharePointResourceId) {
                        return [2 /*return*/];
                    }
                    else if (sharePointResourceId.indexOf('office.com') !== -1) {
                        dispatcher = dispatcherModule.getDispatcher();
                        dispatcher &&
                            dispatcher.dispatch({
                                name: 'generic_error',
                                nameDetail: 'InvalidSharePointResourceId',
                                eventType: 'USAGE',
                                properties: {},
                            });
                    }
                    return [2 /*return*/, queryCache.fetchQuery('SearchWarmupPersonalData', function () {
                            return prefetch.fetchPersonalData({
                                tokenProvider: sharePointTokenProvider,
                                url: "".concat(sharePointResourceId, "/_api/SP.UserProfiles.PeopleManager/GetMyProperties?$select=AccountName,PersonalUrl,UserUrl"),
                            });
                        }, {
                            cacheTime: Infinity,
                            staleTime: Infinity,
                            enabled: !!shouldFetchPersonalData,
                        })];
            }
        });
    });
}
//# sourceMappingURL=warmupPersonalData.js.map